import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import Providers from "./components/PrivyProvider";
import { store } from "./store";

// Ensure the root element exists before rendering
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error(
    'Root element not found. Please ensure there is a <div id="root"> in your HTML.'
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers>
      <Provider store={store}>
        <App />
      </Provider>
    </Providers>
  </StrictMode>
);
